var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.999878,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.999878,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#ECE9E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8342 27.9999C27.6752 27.9999 29.1675 26.5075 29.1675 24.6665V17.1854C29.1678 17.1727 29.1678 17.1599 29.1675 17.1471V16.3332C29.1675 14.4923 27.6752 12.9999 25.8342 12.9999H14.1675C12.3266 12.9999 10.8342 14.4923 10.8342 16.3332V17.1471C10.8339 17.1599 10.8339 17.1727 10.8342 17.1854V24.6665C10.8342 26.5075 12.3266 27.9999 14.1675 27.9999H25.8342ZM12.5009 24.6665C12.5009 25.587 13.2471 26.3332 14.1675 26.3332H25.8342C26.7547 26.3332 27.5009 25.587 27.5009 24.6665V18.3974L21.2388 20.9022C20.4441 21.2201 19.5576 21.2201 18.7629 20.9022L12.5009 18.3974V24.6665ZM20.6199 19.3548L27.5009 16.6024V16.3332C27.5009 15.4127 26.7547 14.6665 25.8342 14.6665H14.1675C13.2471 14.6665 12.5009 15.4127 12.5009 16.3332V16.6024L19.3819 19.3548C19.7792 19.5137 20.2225 19.5137 20.6199 19.3548Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactMail);
export default __webpack_public_path__ + "static/media/contactMail.e7656cc26e65d27cf52bd68d742ff3d4.svg";
export { ForwardRef as ReactComponent };